import { linkedAccountsQueryKeys as e } from "./useLinkedAccountsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/useLinkedAccountsQuery.ts
var r = (r = !0) => t({
	queryKey: e.list(),
	queryFn: n.getLinkedAccounts,
	enabled: r
});
//#endregion
export { r as useLinkedAccountsQuery };
